export class UserNotifMessageData {
  notificationID!: any;
  message!: string;
  userId!: number;
  shipId!: number;
  requestModule!: string;
  requestId!: any;
  userNotificationTypeId!: number;
  exceptionRequestModule!: string;
  createUserId!: number;
}
